import { useNuxtApp, defineNuxtRouteMiddleware } from 'nuxt/app';
import { useUser } from '~/composables/user';
import { useCareerChat } from '~/composables/career/chats';

export default defineNuxtRouteMiddleware(async(to) => {
  const allowedPaths = ['/login', '/ticket-box'];
  if (!allowedPaths.some((path) => to.path.startsWith(path))) {
    const { $auth, $userServiceAxios } = useNuxtApp();
    const { fetchCurrentUserProfile } = useUser();
    const { fetchChatMessageStatus } = useCareerChat();
    const token = await $auth.getToken();
    if (token !== null) {
      await fetchCurrentUserProfile();
      await fetchChatMessageStatus($userServiceAxios);
    }
  }
});
